import RatingStars from "@/components/rating/RatingStars";

interface ReviewItemProps {
  review: any;
}

const ReviewItem: React.FC<ReviewItemProps> = ({ review }) => {
  return (
    <div className="border-b border-gray-300 py-4 px-5 w-full">
      <RatingStars rating={review.rating} onRatingChange={() => {}} />
      <h3 className="font-semibold">{review.title}</h3>
      <p className="text-sm text-gray-600">{`${
        review.author
      } on ${new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(review.date))}`}</p>
      <p>{review.content}</p>
      <div className="text-right">
        <button
          className="text-[12px] text-gray-500 hover:text-gray-700 transition-colors duration-300 underline"
          onClick={() => {
            /* Add your logic for reporting the review here */
          }}
        >
          Report as Inappropriate
        </button>
      </div>
    </div>
  );
};

export default ReviewItem;
